<!-- 结算操作 -->
<template>
    <div v-loading="loading" class="settle-content" id="settleOp">
        <div class="search-ctn">
            <div class="search-ctn-left">
                <div class="flex">
                    <div class="search-name">账期时间</div>
                    <el-date-picker
                        v-model="dateTimes"
                        type="daterange"
                        align="right"
                        unlink-panels
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        :picker-options="pickerOptions"
                        @change="handleChange"
                        size="small"
                        class="search-name"
                        :disabled="SType == 2"
                    ></el-date-picker>
                    <div class="search-name">客户</div>
                    <el-select
                        class="search-item"
                        size="small"
                        style="width: 80%"
                        :loading="loading"
                        v-model="cusId"
                        filterable
                        clearable
                        remote
                        reserve-keyword
                        :remote-method="searchCustomer"
                        v-select-scroll-more="searchCustomerLoad"
                        @change="customerChange($event)"
                        @visible-change="customerVisibleChange($event)"
                        placeholder="选择需要结算的客户"
                        :disabled="SType == 2"
                    >
                        <el-option
                            v-for="optionItem in customerList"
                            :key="optionItem.EntpCusId"
                            :data-msg="optionItem"
                            :label="optionItem.EntpCusName"
                            :value="optionItem.EntpCusId"
                        ></el-option>
                    </el-select>
                    <div class="search-name">供应商</div>
                    <el-select
                        class="search-item"
                        size="small"
                        style="width: 60%"
                        :loading="loading"
                        v-model="supId"
                        filterable
                        clearable
                        remote
                        reserve-keyword
                        allow-create
                        :remote-method="searchSupplier"
                        v-select-scroll-more="searchSupplierLoad"
                        @change="supplierChange($event)"
                        @visible-change="supplierVisibleChange($event)"
                        placeholder="选择需要结算的供应商"
                        :disabled="SType == 2"
                    >
                        <el-option
                            v-for="optionItem in supplierList"
                            :key="optionItem.EntpCusId"
                            :data-msg="optionItem"
                            :label="optionItem.EntpCusName"
                            :value="optionItem.EntpCusId"
                        ></el-option>
                    </el-select>
                    <div class="search-name" v-if="SType != 2">
                        <el-button size="small" icon="el-icon-search" class="search-btn btn-primary" @click="handleSearch">查询</el-button>
                        <el-button size="small" icon="el-icon-refresh" class="search-btn btn-primary" @click="resetSearch">重置</el-button>
                    </div>
                </div>
            </div>
        </div>
        <div class="tags">
            <el-tag v-for="tag in cusTags" :key="tag.name + 'c'" closable class="c-item" @close="closeCusTag(tag.id)"> {{ tag.name }} </el-tag
            ><el-tag v-for="tag in supTags" :key="tag.name + 's'" closable type="success" class="c-item" @close="closeSupTag(tag.id)">
                {{ tag.name }}
            </el-tag>
        </div>
        <div class="table-ctn">
            <el-table
                :header-cell-style="{ background: '#F2F6FC' }"
                v-loading="loading"
                :data="tableData"
                border
                ref="multipleTable"
                height="400px"
                show-summary
                :summary-method="getSummaries"
                style="width: 100%; margin-bottom: 10px"
                @selection-change="handleSelectionChange"
            >
                <el-table-column type="selection" width="55" v-if="!this.SettleId"></el-table-column>
                <el-table-column show-overflow-tooltip width="52px" type="index" label="序号"></el-table-column>
                <el-table-column show-overflow-tooltip width="95" prop="Date" label="创建时间"></el-table-column>
                <el-table-column show-overflow-tooltip width="190" prop="OrderCode" label="单号"></el-table-column>
                <el-table-column show-overflow-tooltip width="80" prop="PRType" label="款项类型"></el-table-column>
                <el-table-column show-overflow-tooltip min-width="90" prop="SurplusFund" label="期初余额"
                    ><template scope="scope">{{ scope.row.SurplusFund == 0 ? '' : scope.row.SurplusFund }}</template></el-table-column
                >
                <el-table-column label="借方金额">
                    <el-table-column show-overflow-tooltip min-width="90" prop="AdvancePayment" label="预付账款"
                        ><template scope="scope">{{ scope.row.AdvancePayment == 0 ? '' : scope.row.AdvancePayment }}</template></el-table-column
                    >
                    <el-table-column show-overflow-tooltip min-width="90" prop="NeedReceive" label="应收账款"
                        ><template scope="scope">{{ scope.row.NeedReceive == 0 ? '' : scope.row.NeedReceive }}</template></el-table-column
                    >
                </el-table-column>
                <el-table-column label="贷方金额">
                    <el-table-column show-overflow-tooltip min-width="90" prop="AdvanceReceived" label="预收账款"
                        ><template scope="scope">{{ scope.row.AdvanceReceived == 0 ? '' : scope.row.AdvanceReceived }}</template></el-table-column
                    >
                    <el-table-column show-overflow-tooltip min-width="90" prop="NeedPay" label="应付账款"
                        ><template scope="scope">{{ scope.row.NeedPay == 0 ? '' : scope.row.NeedPay }}</template></el-table-column
                    >
                </el-table-column>
                <el-table-column show-overflow-tooltip min-width="90" prop="Balance" label="余额"></el-table-column>
                <el-table-column show-overflow-tooltip min-width="90" prop="Remark" label="备注"></el-table-column>
                <el-table-column show-overflow-tooltip width="100" prop="Applier" label="经手人"></el-table-column>
                <el-table-column label="操作" width="60" v-if="SType != 2 && this.SettleId">
                    <template slot-scope="scope">
                        <div>
                            <el-button title="移除" size="small" type="text" @click="delItem(scope.row)" style="color: red">移除</el-button>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="search-ctn">
            <div class="flex">
                <div class="search-name">结算单备注</div>
                <el-input class="search-item" size="small" :disabled="SType == 2" v-model.trim="submitData.Remark" placeholder="请输入备注内容"></el-input>
            </div>
        </div>
        <div class="dialog-footer" v-if="SType != 2">
            <div class="re-submit">
                <!-- <el-checkbox v-if="isCanRele" class="chk" v-model="isRele"
        >是否进行实体关联</el-checkbox
      > -->
                <el-button class="btn-primary" @click="submitForm(0)">保存结算单</el-button>
                <el-button class="btn-primary" @click="submitForm(1)">提交结算单</el-button>
                <el-button @click="cancel()">取消</el-button>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: '',
    props: ['SettleId', 'SType'],
    components: {},
    data() {
        return {
            loading: false,
            isCanRele: false,
            isRele: false,
            dateTimes: [],
            cusId: '',
            supId: '',
            sName: '',
            customerList: [],
            supplierList: [],
            submitData: {
                SettleId: this.SettleId,
                OldIds: [],
                NewIds: [],
                RecordIds: [],
                StartDate: '',
                EndDate: '',
                SubmitState: '',
                Remark: ''
            },
            cusTags: [],
            supTags: [],
            newReleIds: [],
            searchData: {
                SettleId: this.SettleId,
                CusIds: [],
                StartDate: '',
                EndDate: ''
            },
            tableData: [],
            pickerOptions: {
                shortcuts: [
                    {
                        text: '最近一周',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近一个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近三个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近半年',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 180);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近一年',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 365);
                            picker.$emit('pick', [start, end]);
                        }
                    }
                ]
            },
            // 用于客户列表，分页搜索
            customerForm: {
                Page: 1,
                Limit: 10,
                stopLoad: false,
                key: ''
            },
            // 用于供应商列表，分页搜索
            supplierForm: {
                Page: 1,
                Limit: 10,
                stopLoad: false,
                key: ''
            }
        };
    },
    updated() {
        this.$nextTick(() => {
            this.$refs['multipleTable'].doLayout();
        });
    },
    mounted() {
        if (this.SettleId) this.getTableData(0);
        else {
            this.resetSearch();
            this.tableData = [];
        }
        let dialogbody = document.querySelector('#settleOp');
        this.$util.setEventForDialog(this, dialogbody);
        // 打开时禁止页面滚动
        document.body.style = 'overflow:hidden';
    },
    destroyed() {
        document.body.style = 'overflow:auto';
    },
    methods: {
        resetSearch() {
            this.searchData = {
                SettleId: this.SettleId,
                CusIds: [],
                StartDate: '',
                EndDate: ''
            };
            this.cusId = '';
            this.supId = '';
            this.cusTags = [];
            this.supTags = [];
            this.dateTimes = [];
        },
        // 更新表格数据
        updateTableData(id) {
            this.resetSearch();
            this.getTableData(2, id);
        },
        getTableData(type, id) {
            let that = this;
            if (type == 0) {
                that.searchData.SettleId = that.SettleId;
            } else {
                that.searchData.SettleId = '';
            }

            if (id) {
                that.searchData.SettleId = id;
            }

            that.loading = true;
            that.newReleIds = [];
            if (that.cusTags.length > 0) {
                for (let index = 0; index < that.cusTags.length; index++) {
                    if (that.newReleIds.findIndex(x => x == that.cusTags[index].id) == -1) {
                        that.newReleIds.push(that.cusTags[index].id);
                    }
                }
            }
            if (that.supTags.length > 0) {
                for (let index = 0; index < that.supTags.length; index++) {
                    if (that.newReleIds.findIndex(x => x == that.supTags[index].id) == -1) {
                        that.newReleIds.push(that.supTags[index].id);
                    }
                }
            }
            that.searchData.CusIds = that.newReleIds;
            that.$util
                .axiosPost({
                    url: '/api/RevenueManagement/GetFinancialRecords',
                    data: that.searchData,
                    hideLoading: true
                })
                .then(res => {
                    let data = res.data;
                    if (data) that.tableData = data.DetailsList;
                    else {
                        that.tableData = [];
                        return;
                    }

                    if (that.tableData.length > 0) {
                        let balance = 0;
                        for (let index = 0; index < that.tableData.length; index++) {
                            balance +=
                                that.tableData[index].SurplusFund +
                                that.tableData[index].AdvancePayment +
                                that.tableData[index].NeedReceive -
                                that.tableData[index].AdvanceReceived -
                                that.tableData[index].NeedPay;
                            balance = balance.toFixed(2) * 1;
                            that.tableData[index].Balance = balance;
                        }
                    }

                    if (data.CustomerList) {
                        that.cusTags = data.CustomerList;
                    }
                    if (data.SupplierList) {
                        that.supTags = data.SupplierList;
                    }
                    if (data.StartDate) {
                        that.dateTimes.push(data.StartDate);
                    }

                    if (data.EndDate) {
                        that.dateTimes.push(data.EndDate);
                    }

                    if (data.Remark) {
                        that.submitData.Remark = data.Remark;
                    }
                })
                .catch(() => {})
                .finally(() => {
                    this.loading = false;
                    this.chackRele();
                });
        },
        handleSearch() {
            this.getTableData(1);
        },
        handleChange(val) {
            if (val) {
                this.searchData.StartDate = val[0];
                this.searchData.EndDate = val[1];

                this.submitData.StartDate = val[0];
                this.submitData.EndDate = val[1];
            } else {
                this.searchData.StartDate = '';
                this.searchData.EndDate = '';

                this.submitData.StartDate = '';
                this.submitData.EndDate = '';
            }
        },
        // 搜索顾客
        searchCustomer(key) {
            if (![undefined].includes(key)) {
                this.customerForm.Page = 1;
                this.customerForm.stopLoad = false;
                this.customerForm.key = key;
                this.customerList = [];
            }
            if (this.customerForm.stopLoad) return;
            this.$util
                .searchCustomer(this.customerForm.key, this.customerForm.Page, this.customerForm.Limit)
                .then(data => {
                    if (!data) return;
                    this.customerForm.stopLoad = data.length < this.customerForm.Limit;
                    this.customerList = [...this.customerList, ...data];
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        searchCustomerLoad() {
            this.customerForm.Page += 1;
            this.searchCustomer();
        },
        //当客户下拉框出现时触发
        customerVisibleChange(event) {
            let that = this;
            if (event) {
                if (that.customerList.length <= 1) that.searchCustomer('');
            }
        },
        customerChange(value) {
            let that = this;
            let currCust = that.customerList.find(e => e.EntpCusId == value);
            if (currCust) {
                let EntpCusName = currCust.EntpCusName;
                let isHad = false;
                for (var i = 0; i < that.cusTags.length; i++) {
                    if (this.cusTags[i].id === value) {
                        isHad = true;
                    }
                }
                if (!isHad) that.cusTags.push({ name: EntpCusName, id: value });
            }
            that.eCusId = value;
            that.getReleData();
            that.chackRele();
        },
        //搜索供应商
        searchSupplier(key) {
            if (![undefined].includes(key)) {
                this.supplierForm.Page = 1;
                this.supplierForm.stopLoad = false;
                this.supplierForm.key = key;
                this.supplierList = [];
            }
            if (this.supplierForm.stopLoad) return;
            this.$util
                .searchSupplier(this.supplierForm.key, this.supplierForm.Page, this.supplierForm.Limit)
                .then(data => {
                    if (!data) return;
                    this.supplierForm.stopLoad = data.length < this.supplierForm.Limit;
                    this.supplierList = [...this.supplierList, ...data];
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        // 供应商列表，加载更多
        searchSupplierLoad() {
            this.supplierForm.Page += 1;
            this.searchSupplier();
        },
        //当客户下拉框出现时触发
        supplierVisibleChange(event) {
            let that = this;
            if (event) {
                if (that.supplierList.length <= 1) that.searchSupplier('');
            }
        },
        supplierChange(value) {
            let that = this;

            let currCust = that.supplierList.find(e => e.EntpCusId == value);
            if (currCust) {
                let EntpCusName = currCust.EntpCusName;
                let isHad = false;
                for (var i = 0; i < that.supTags.length; i++) {
                    if (that.supTags[i].id === value) {
                        isHad = true;
                        break;
                    }
                }
                if (!isHad) that.supTags.push({ name: EntpCusName, id: value });
            }

            that.eCusId = value;
            that.getReleData();
        },
        closeCusTag(val) {
            if (val) {
                for (var i = 0; i < this.cusTags.length; i++) {
                    if (this.cusTags[i].id === val) {
                        this.cusTags.splice(i, 1);
                    }
                }
                this.getTableData(1);
            }
        },
        closeSupTag(val) {
            if (val) {
                for (var i = 0; i < this.supTags.length; i++) {
                    if (this.supTags[i].id === val) {
                        this.supTags.splice(i, 1);
                    }
                }
                this.getTableData(1);
            }
        },
        getSummaries(param) {
            const { columns, data } = param;
            const sums = [];
            columns.forEach((column, index) => {
                if (this.SettleId) {
                    if (index === 3) {
                        sums[index] = '结算：';
                        return;
                    }
                    if (index === 4 || index === 5 || index === 6 || index === 7 || index === 8) {
                        const values = data.map(item => Number(item[column.property]));
                        if (!values.every(value => isNaN(value))) {
                            sums[index] = values.reduce((prev, curr) => {
                                const value = Number(curr);
                                if (!isNaN(value)) {
                                    return prev + curr;
                                } else {
                                    return prev;
                                }
                            }, 0);
                            sums[index] = sums[index].toFixed(2) * 1;
                        } else {
                            sums[index] = '';
                        }
                    }
                    if (index === 9) {
                        sums[index] = sums[4] + sums[5] + sums[6] - sums[7] - sums[8];

                        if (sums[index] == 0) sums[index] = '结清';
                        else sums[index] = ' = ' + sums[index].toFixed(2) * 1;
                    }
                } else {
                    if (index === 4) {
                        sums[index] = '结算：';
                        return;
                    }
                    if (index === 5 || index === 6 || index === 7 || index === 8 || index === 9) {
                        let newData = [];
                        if (this.submitData.RecordIds.length > 0) {
                            for (let index = 0; index < this.submitData.RecordIds.length; index++) {
                                let ele = this.submitData.RecordIds[index];
                                let curr = this.tableData.find(e => e.RecordId == ele);
                                newData.push(curr);
                            }

                            const values = newData.map(item => Number(item[column.property]));
                            if (!values.every(value => isNaN(value))) {
                                sums[index] = values.reduce((prev, curr) => {
                                    const value = Number(curr);
                                    if (!isNaN(value)) {
                                        return prev + curr;
                                    } else {
                                        return prev;
                                    }
                                }, 0);
                                sums[index] = sums[index].toFixed(2) * 1;
                            } else {
                                sums[index] = '';
                            }
                        }
                    }

                    if (index === 10) {
                        sums[index] = Number(sums[5] + sums[6] + sums[7] - sums[8] - sums[9]);
                        if (isNaN(sums[index])) sums[index] = 0;
                        else {
                            if (sums[index] == 0) sums[index] = '结清';
                            else sums[index] = ' = ' + sums[index].toFixed(2) * 1;
                        }
                    }
                }
            });

            return sums;
        },
        chackRele() {
            if (this.newReleIds.length > 1) {
                if (this.submitData.OldIds.length != this.newReleIds.length) this.isCanRele = true;
            } else {
                this.isCanRele = false;
                this.isRele = false;
            }
        },
        getReleData() {
            this.loading = true;
            this.$util
                .axiosGet({
                    url: '/api/RevenueManagement/GetEntityReleDatas',
                    data: { EntpCusId: this.eCusId },
                    hideLoading: true
                })
                .then(res => {
                    if (res.data) {
                        var newArr = [];
                        if (res.data.CustomerList.length > 0) {
                            res.data.CustomerList.forEach(el => {
                                var isContain = false;
                                for (var i = 0; i < this.cusTags.length; i++) {
                                    if (el.id == this.cusTags[i].id) {
                                        isContain = true;
                                        break;
                                    } else {
                                        isContain = false;
                                    }
                                }
                                if (!isContain) {
                                    newArr.push(el);
                                }
                            });
                            this.cusTags = this.cusTags.concat(newArr);
                        }
                        if (res.data.SupplierList.length > 0) {
                            res.data.SupplierList.forEach(el => {
                                var isContain = false;
                                for (var i = 0; i < this.supTags.length; i++) {
                                    if (el.id == this.supTags[i].id) {
                                        isContain = true;
                                        break;
                                    } else {
                                        isContain = false;
                                    }
                                }
                                if (!isContain) {
                                    newArr.push(el);
                                }
                            });
                            this.supTags = this.supTags.concat(newArr);
                        }
                        if (res.data.AllReleIds.length > 0) {
                            res.data.AllReleIds.forEach(el => {
                                var isContain = false;
                                for (var i = 0; i < this.submitData.OldIds.length; i++) {
                                    if (el.id == this.submitData.OldIds[i]) {
                                        isContain = true;
                                        break;
                                    } else {
                                        isContain = false;
                                    }
                                }
                                if (!isContain) {
                                    newArr.push(el);
                                }
                            });
                            this.submitData.OldIds = this.submitData.OldIds.concat(newArr);
                        }

                        this.getTableData(1);
                    }
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        submitForm(type) {
            let that = this;
            if (that.SettleId) {
                that.submitData.RecordIds = [];
                if (that.tableData.length > 0) {
                    that.tableData.forEach(item => {
                        that.submitData.RecordIds.push(item.RecordId);
                    });
                } else {
                    that.$util.warningMsg('结算单必须具有结算明细项');
                    return;
                }
            } else {
                that.submitData.OldIds = [];
                if (that.submitData.RecordIds.length == 0) {
                    that.$util.warningMsg('结算单必须具有结算明细项');
                    return;
                }
            }
            that.submitData.NewIds = [];

            if (that.cusTags.length > 0) {
                for (let index = 0; index < that.cusTags.length; index++) {
                    that.newReleIds.push(that.cusTags[index].id);
                }
            }
            if (that.supTags.length > 0) {
                for (let index = 0; index < that.supTags.length; index++) {
                    that.newReleIds.push(that.supTags[index].id);
                }
            }

            that.submitData.NewIds = that.newReleIds;
            if (type == 0) {
                that.submitData.SubmitState = '0';
                that.loading = true;
                that.$util
                    .axiosPost({
                        url: '/api/RevenueManagement/SaveSettlementDatas',
                        data: that.submitData,
                        hideLoading: true
                    })
                    .then(res => {
                        that.$util.successMsg(res.errmsg);
                        if (res.errcode === 0) {
                            that.cancel();
                        }
                    })
                    .finally(() => {
                        that.loading = false;
                    });
            } else {
                that.$confirm('您确认要提交结算单吗？一旦提交则不能再进行修改', '提示', {
                    confirmButtonText: '确定提交',
                    cancelButtonText: '取消',
                    type: 'warning',
                    center: false
                })
                    .then(() => {
                        that.submitData.SubmitState = '1';
                        that.loading = true;
                        that.$util
                            .axiosPost({
                                url: '/api/RevenueManagement/SaveSettlementDatas',
                                data: that.submitData,
                                hideLoading: true
                            })
                            .then(res => {
                                that.$util.successMsg(res.errmsg);
                                if (res.errcode === 0) {
                                    that.cancel();
                                }
                            })
                            .finally(() => {
                                that.loading = false;
                            });
                    })
                    .catch(() => {});
            }
        },
        cancel() {
            this.$emit('closeDialog');
        },
        delItem(item) {
            let that = this;
            if (item) {
                that.submitData.RecordIds.splice(that.submitData.RecordIds.indexOf(item.RecordId), 1);
                that.tableData.splice(that.tableData.indexOf(item), 1);

                if (that.tableData.length > 0) {
                    let balance = 0;
                    for (let index = 0; index < that.tableData.length; index++) {
                        balance +=
                            that.tableData[index].SurplusFund +
                            that.tableData[index].AdvancePayment +
                            that.tableData[index].NeedReceive -
                            that.tableData[index].AdvanceReceived -
                            that.tableData[index].NeedPay;
                        that.tableData[index].Balance = balance;
                    }
                }
            }
        },
        // 勾选统计
        handleSelectionChange(val) {
            this.multipleSelection = val;
            let idList = [];
            for (let i = 0; i < val.length; i++) {
                idList.push(val[i].RecordId);
            }
            this.submitData.RecordIds = idList;
        }
    }
};
</script>
<style lang="less" scoped>
.tags {
    margin-bottom: 10px;

    .c-item {
        margin-right: 5px;
    }
}
.chk {
    margin-right: 10px;
}
.re-submit {
    text-align: right;
}
</style>
